<template>
  <nav class="navbar bg-body-tertiary">
    <div class="container">
      <!-- Use a normal <a> tag for external links -->
      <a class="navbar-brand" href="https://origin.co.th/" target="_blank">
        <img src="../assets/logo_origin_og.png" alt="Logo" style="width: 130px;">
      </a>
      <form class="d-flex">
        <span class="">
          <router-link class="navbar-brand fs-6" to="/">
            <img src="../assets/ic_round-home.svg" class="mb-1">
            <small> หน้าหลักนักลงทุนสัมพันธ์</small>
          </router-link>
        </span>
      </form>
    </div>
  </nav>
</template>

  
<script>
export default {
  name: 'AppNavbar',
  data() {
    return {
      selectedLanguage: 'th', // Default language is Thai
    };
  },
  computed: {
    selectedLanguageText() {
      return this.selectedLanguage === 'en' ? 'English' : 'ไทย';
    }
  },
  methods: {
    selectLanguage(language) {
      this.selectedLanguage = language;
      console.log(`Language selected: ${language}`);
      // Implement additional language switching logic here, if needed
    },
  },
};
</script>
<style>
.bg {
  box-shadow: 0px 2px 10px 0px #0000000D;
}
</style>